import { MaterialUnloadShedPost, MaterialUnloadShedPut, MaterialUnloadShedSearch } from '../interfaces/MaterialUnloadShed';
import { getUrlMvmApi } from '../utils/util';
import ApiHandler from './ApiHandler';

//export const baseURL = "https://localhost:5001";
export const baseURL = String(getUrlMvmApi(window));

export default class MaterialUnloadShedApi {
    static async searchMaterialUnloadShed(params: MaterialUnloadShedSearch) {
        const queryParts: string[] = [];
        if (params.companyId) queryParts.push(`CompanyId=${params.companyId}`);
        if (params.companyIds && params.companyIds.length > 0) {
            params.companyIds.forEach(id => queryParts.push(`CompanyIds=${id}`));
        }
        if (params.shedCode) queryParts.push(`ShedCode=${encodeURIComponent(params.shedCode)}`);
        if (params.partNumberId && params.partNumberId.length > 0) {
            params.partNumberId.forEach(id => queryParts.push(`PartNumberId=${id}`));
        }
        if (params.partNumberCodes && params.partNumberCodes.length > 0) {
            params.partNumberCodes.forEach(code => queryParts.push(`PartNumberCodes=${encodeURIComponent(code)}`));
        }
        queryParts.push(`PageSize=${params.pageSize}`);
        queryParts.push(`PageIndex=${params.pageIndex}`);
        const queryString = queryParts.length > 0 ? `?${queryParts.join('&')}` : '';
        var response = await ApiHandler(baseURL).get(`material-unload-shed/search${queryString}`);
        return response.data;
    }

    static async getMaterialUnloadShed(companyId: number, partNumberId: number) {
        var response = await ApiHandler(baseURL).get(`material-unload-shed?companyId=${companyId}&partNumberId=${partNumberId}`);
        return response.data;
    }

    static async postMaterialUnloadShed(post: MaterialUnloadShedPost) {
        var response = await ApiHandler(baseURL).post('material-unload-shed', post);
        return response.data;
    }

    static async putMaterialUnloadShed(put: MaterialUnloadShedPut) {
        var response = await ApiHandler(baseURL).put('material-unload-shed', put);
        return response.data;
    }

    static async deleteMaterialUnloadShed(partNumberId: number) {
        var response = await ApiHandler(baseURL).delete(`material-unload-shed?partNumberId=${partNumberId}`);
        return response.data;
    }
}
